import { render } from "./deployCloud.vue?vue&type=template&id=f2729a18&scoped=true"
import script from "./deployCloud.vue?vue&type=script&lang=js"
export * from "./deployCloud.vue?vue&type=script&lang=js"

import "./deployCloud.vue?vue&type=style&index=0&id=f2729a18&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2729a18"]])

export default __exports__